import { createI18n } from "vue-i18n";
import ruRU from "./ru_RU.json";

export type MessageSchema = typeof ruRU;

export type Locales = "ru" | "en";

function ruPlural(choice: number, choicesLength: number): number {
  if (choice === 0) return 0;
  const teen = choice % 100 > 10 && choice % 100 < 20;
  const last = choice % 10;
  if (!teen && last === 1) return 1;
  if (!teen && last >= 2 && last <= 4) return 2;
  return choicesLength < 4 ? 2 : 3;
}


const i18n = createI18n<{ message: MessageSchema }, Locales>({
  locale: "ru",
  fallbackLocale: "ru",
  legacy: false,
  pluralRules: { ru: ruPlural },
  messages: {
    ru: ruRU,
  } as Record<Locales, MessageSchema>,
});

const loadedLocales = new Set<Locales>(["ru"]);

export function intlLocale(locale: string): string {
  return normalizeLocale(locale) === "en" ? "en-US" : "ru-RU";
}

/** Normalizes full locale codes (e.g. ru_RU, en_US) to registered keys (ru, en) */
export function normalizeLocale(locale: string): Locales {
  const lower = locale.toLowerCase();
  if (lower.startsWith("ru")) return "ru";
  if (lower.startsWith("en")) return "en";
  return "ru"; // fallback
}

export function localeToLanguage(locale: string): string {
  switch (locale) {
    case "ru":
      return "Русский";
    case "en":
      return "English";
    default:
      return "???";
  }
}

export async function loadLocaleMessages(locale: Locales): Promise<void> {
  if (loadedLocales.has(locale)) return;

  if (locale === "en") {
    const { default: enUS } = await import("./en_US.json");
    i18n.global.setLocaleMessage("en", enUS);
    loadedLocales.add("en");
  }
}

export async function applyAppLocale(rawLocale: string): Promise<Locales> {
  const locale = normalizeLocale(rawLocale);
  await loadLocaleMessages(locale);
  (i18n.global.locale as unknown as { value: Locales }).value = locale;
  return locale;
}

export default i18n;
